// What Free resources and Free webinars read and write beyond the Library's rows, as the member
// themselves (docs/data-model.md 6 and 10.1). Row level security decides what comes back: their own
// activity and replay progress, and the shown webinars of a Free webinars product they're not held
// back from. The 2 functions answer only a logged-in member, refuse while staff view as a member,
// and take the name and email from the database, never from here.
import { supabase, must } from '../lib/supabase.js'
import { callHubFunction } from '../lib/functions.js'

// The page's own read of the webinars, with what the Library's read leaves out: the description,
// the registration link, what it sells, the call to action and the replay. thumbnail_path is Adam's
// own thumbnail (Adam, 9 Oct), on the card and behind the replay's play button.
export const WEBINAR_COLUMNS = 'id, title, description, starts_at, duration_minutes, registration_url, shown, '
  + 'sells_product_id, cta_text, cta_label, cta_url, replay_url, replay_up, replay_chapters, replay_duration_seconds, thumbnail_path'

// Free resources: their own joins, for the Restart Challenge's joined state. The guide's
// "Downloaded" isn't read back: on the board it shows after the click, until the page is left.
export async function loadJoins(personId) {
  return supabase.from('activity').select('product_id, occurred_at')
    .eq('person_id', personId).eq('kind', 'joined')
    .then(must)
}

// Free webinars: every webinar they can see, and where they are in each replay
export async function loadWebinarPage(personId) {
  const [webinars, progress] = await Promise.all([
    supabase.from('webinars').select(WEBINAR_COLUMNS).then(must),
    supabase.from('replay_progress').select('webinar_id, position_seconds, watched_at').eq('person_id', personId).then(must),
  ])
  return { webinars, progress }
}

// Taking the scorecard: their own "opened" row (the activity_insert policy), for AdminPerson's
// "Opened on Sat 12 Sep, from the hub". It never holds up the new tab.
export async function recordOpened(personId, productId) {
  must(await supabase.from('activity').insert({ person_id: personId, product_id: productId, kind: 'opened' }))
}

// A replay's place. Only the position: watched_at is the database's.
export async function saveReplayPosition(personId, webinarId, seconds) {
  must(await supabase.from('replay_progress').upsert(
    { person_id: personId, webinar_id: webinarId, position_seconds: Math.max(0, Math.floor(seconds || 0)) },
    { onConflict: 'person_id,webinar_id' },
  ))
}

// The guide: a link signed for 2 minutes, opened at once and never kept (sign-file). A refusal
// throws a HubFunctionError whose message is the function's own line to show.
export function signFile(placementId) {
  return callHubFunction('sign-file', { placement_id: placementId })
}

// The Restart Challenge: { ok, already, joined_at } (restart-join)
export function joinRestart() {
  return callHubFunction('restart-join', {})
}

// The property strategy tool's saved report (Stage 2, docs/property-strategy-spec.md S2.8): the person's latest saved
// result, read under row level security (their own rows, or the viewed member's while staff view as them), or null.
// Free resources reads it too, for its line back to the report and the starter guide under it.
export const STRATEGY_COLUMNS = 'id, version, answers, history, contexts, created_at, lead_status'
export async function loadSavedStrategy(personId) {
  const rows = await supabase.from('strategy_results').select(STRATEGY_COLUMNS)
    .eq('person_id', personId).order('created_at', { ascending: false }).order('id').limit(1)
    .then(must)
  return rows[0] || null
}
